import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import "assets/scss/material-dashboard-pro-react/plugins/_plugin-react-datepicker.css";
import styles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import DatePicker from "react-datepicker";
import Username from "components/CustomInput/Username.js";
import "react-datepicker/dist/react-datepicker.css";
import StarRatingComponent from "react-star-rating-component";

// react component for creating dynamic tables
// @material-ui/core components
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Radio from "@material-ui/core/Radio";

import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

// import { makeStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CardAvatar from "components/Card/CardAvatar.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import ProfilePreview from "view2/ProfilePreview.jsx";
import CardFooter from "components/Card/CardFooter.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import getCheckIn from "api/checkIn/get";
import addReview from "api/review/addReview";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles(styles);

function GetStar(prop) {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ fontSize: "16px", fontWeight: 600 }}>{prop.name}</div>
      <div style={{}}>
        <StarRatingComponent
          name="rate1"
          starCount={10}
          style={{ height: "20px", width: "20px", float: "right" }}
          value={prop.value}
          onStarClick={e => {}}
          editing={false}
          renderStarIcon={(index, value) => {
            return (
              <span>
                <span>
                  <i
                    style={{ color: "rgb(255, 180, 0)" }}
                    className={index <= value ? "fas fa-star" : "far fa-star"}
                  />
                </span>
              </span>
            );
          }}
          renderStarIconHalf={() => {
            return (
              <span>
                <span style={{ position: "absolute" }}>
                  <i
                    style={{ color: "rgb(255, 180, 0)" }}
                    className="far fa-star"
                  />
                </span>
                <span>
                  <i
                    style={{ color: "rgb(255, 180, 0)" }}
                    className="fas fa-star-half"
                  />
                </span>
              </span>
            );
          }}
        />
      </div>
    </div>
  );
}

export default function UserData(props) {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const [checkIn, setCheckin] = useState([]);
  useEffect(() => {
    getCheckIn().then(e => {
      setCheckin(e);
    });
  }, []);
  const [type, setType] = React.useState([
    { name: "location", score: 1 },
    { name: "service", score: 1 },
    { name: "menu", score: 1 },
    { name: "qualità", score: 1 }
  ]);
  const [alert, setAlert] = React.useState(null);
  return (
    <GridContainer
      justify={"center"}
      style={{ margin: "20px", marginTop: "100px", width: "calc(100% - 30px)" }}
    >
      {checkIn.map(e => (
        <GridItem xs={10} md={4} lg={3} key={e._id}>
          <Card>
            <CardHeader>
              <div style={{ float: "left", fontSize: "20px", fontWeight: 800 }}>
                {e.restaurantId.name}
              </div>
              <div
                style={{ float: "right", fontSize: "20px", fontWeight: 800 }}
              >
                {e.reviewed && e.reviewed.total.toFixed(2)}
              </div>
            </CardHeader>
            <CardBody>
              {e.reviewed && e.reviewed.total ? (
                <>
                  <GridContainer>
                    <GridItem>
                      <GetStar value={e.reviewed.location} name={"location"} />
                    </GridItem>
                    <GridItem>
                      <GetStar value={e.reviewed.service} name={"service"} />
                    </GridItem>
                    <GridItem>
                      <GetStar value={e.reviewed.menu} name={"menu"} />
                    </GridItem>
                    <GridItem>
                      <GetStar value={e.reviewed.quality} name={"qualità"} />
                    </GridItem>

                    {/* <GridItem>
                      <GetStar value={e.reviewed.total} name={"totale"} />
                    </GridItem> */}
                  </GridContainer>
                  <GridContainer style={{ marginTop: "20px" }} align={"center"}>
                    <GridItem>{e.reviewed.blob}</GridItem>
                  </GridContainer>
                </>
              ) : (
                <CardAvatar>
                  <img
                    style={{ width: "100%" }}
                    src={e.restaurantId.viewStyleSelected.url}
                  />
                </CardAvatar>
              )}
            </CardBody>
            <CardFooter>
              {e.reviewed && e.reviewed.score ? null : (
                <Button
                  onClick={() => {
                    setAlert({
                      title: `recensisci ${e.restaurantId.name}`,
                      blob: "",
                      restaurantId: e.restaurantId._id,
                      _id: e._id
                    });
                  }}
                >
                  {"recensisci"}
                </Button>
              )}
            </CardFooter>
          </Card>
        </GridItem>
      ))}
      {alert ? (
        <Card
          style={{
            position: "fixed",
            top: "calc(50vh - 250px)",
            width: "500px"
          }}
        >
          <CardHeader>{alert.title}</CardHeader>
          <CardBody>
            {type.map((el, i) => (
              <>
                <div>{el.name}</div>
                <div>
                  <StarRatingComponent
                    key={el.name}
                    name={el.name}
                    starCount={10}
                    value={el.focusValue || el.score}
                    onStarHover={(nextValue, prevValue, name, e) => {
                      const newType = JSON.parse(JSON.stringify(type));
                      const xPos =
                        (e.pageX -
                          e.currentTarget.getBoundingClientRect().left) /
                        e.currentTarget.offsetWidth;

                      if (xPos <= 0.5) {
                        nextValue -= 0.5;
                      }
                      newType[i].focusValue = nextValue;
                      setType(newType);
                    }}
                    onStarHoverOut={(nextValue, prevValue, name) => {
                      const newType = JSON.parse(JSON.stringify(type));
                      newType[i].focusValue = null;
                      setType(newType);
                    }}
                    renderStarIcon={(index, value) => {
                      return (
                        <span>
                          <span>
                            <i
                              style={{ color: "rgb(255, 180, 0)" }}
                              className={
                                index <= value ? "fas fa-star" : "far fa-star"
                              }
                            />
                          </span>
                        </span>
                      );
                    }}
                    renderStarIconHalf={() => {
                      return (
                        <span>
                          <span style={{ position: "absolute" }}>
                            <i
                              style={{ color: "rgb(255, 180, 0)" }}
                              className="far fa-star"
                            />
                          </span>
                          <span>
                            <i
                              style={{ color: "rgb(255, 180, 0)" }}
                              className="fas fa-star-half"
                            />
                          </span>
                        </span>
                      );
                    }}
                    onStarClick={(nextValue, prevValue, name, e) => {
                      const xPos =
                        (e.pageX -
                          e.currentTarget.getBoundingClientRect().left) /
                        e.currentTarget.offsetWidth;

                      if (xPos <= 0.5) {
                        nextValue -= 0.5;
                      }
                      console.log(
                        "name: %s, nextValue: %s, prevValue: %s",
                        name,
                        nextValue,
                        prevValue
                      );
                      // console.log(e);
                      const newType = JSON.parse(JSON.stringify(type));
                      newType[i].score = nextValue;
                      setType(newType);
                    }}
                  />
                </div>
              </>
            ))}
            <CustomInput
              labelText={"descrizione"}
              inputProps={{
                value: alert.blob || "",
                onChange: e => {
                  const newAlert = Object.assign({}, alert);
                  newAlert.blob = e.target.value;
                  setAlert(newAlert);
                },
                autoComplete: "off",
                multiline: true,
                rows: 3
              }}
              id={"blob"}
              formControlProps={{
                fullWidth: true
              }}
            ></CustomInput>

            <CustomInput
              labelText={"Prezzo"}
              inputProps={{
                value: alert.price || "",
                onChange: e => {
                  const newAlert = Object.assign({}, alert);
                  newAlert.price = e.target.value;
                  setAlert(newAlert);
                },
                autoComplete: "off",
                multiline: false,
                type: "number"
              }}
              id={"blob"}
              formControlProps={{
                fullWidth: false
              }}
            ></CustomInput>
          </CardBody>
          <CardFooter>
            <>
              <div>{"totale"}</div>
              <div>
                <StarRatingComponent
                  name="rate1"
                  starCount={10}
                  style={{ height: "20px", width: "20px" }}
                  value={type.reduce((a, b) => a + b.score, 0) / type.length}
                  editing={false}
                  renderStarIcon={(index, value) => {
                    return (
                      <span>
                        <span>
                          <i
                            style={{ color: "rgb(255, 180, 0)" }}
                            className={
                              index <= value ? "fas fa-star" : "far fa-star"
                            }
                          />
                        </span>
                      </span>
                    );
                  }}
                  renderStarIconHalf={() => {
                    return (
                      <span>
                        <span style={{ position: "absolute" }}>
                          <i
                            style={{ color: "rgb(255, 180, 0)" }}
                            className="far fa-star"
                          />
                        </span>
                        <span>
                          <i
                            style={{ color: "rgb(255, 180, 0)" }}
                            className="fas fa-star-half"
                          />
                        </span>
                      </span>
                    );
                  }}
                />
              </div>
              <Button
                onClick={() => {
                  const object = {
                    location: type.find(el => el.name === "location").score,
                    service: type.find(el => el.name === "service").score,
                    menu: type.find(el => el.name === "menu").score,
                    quality: type.find(el => el.name === "qualità").score,
                    total: type.reduce((a, b) => a + b.score, 0) / type.length,
                    score: [].concat(type).concat({
                      name: "total",
                      score: type.reduce((a, b) => a + b.score, 0) / type.length
                    }),
                    blob: alert.blob,
                    price: alert.price,
                    checkInId: alert._id,
                    restaurantId: alert.restaurantId
                  };
                  return addReview(object).then(() => {
                    const newReview = object;
                    const index = checkIn.findIndex(el => el._id === alert._id);
                    const newCheck = JSON.parse(JSON.stringify(checkIn));
                    newCheck[index].reviewed = newReview;
                    setCheckin(newCheck);
                    setAlert(null);
                  });
                }}
              >
                recensisci
              </Button>
            </>
          </CardFooter>
        </Card>
      ) : null}
    </GridContainer>
  );
}
UserData.propTypes = {
  updateCity: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  updateUser: PropTypes.func.isRequired
};
